import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STAKEHOLDERREFERENCE_FEATURE_KEY,
  StakeholderReferenceState,
  StakeholderReferencePartialState,
  stakeholderreferenceAdapter,
  
} from './stakeholderreference.reducer';

// Lookup the 'Stakeholder Reference' feature state managed by NgRx
export const getStakeholderReferenceState = createFeatureSelector<
StakeholderReferencePartialState,
StakeholderReferenceState
>(STAKEHOLDERREFERENCE_FEATURE_KEY);



const { selectAll, selectEntities } = stakeholderreferenceAdapter.getSelectors();






export const getStakeholderReferenceError = createSelector(
    getStakeholderReferenceState,
  (state: StakeholderReferenceState) =>  state.error
);

export const loadingStakeholderReference = createSelector(
    getStakeholderReferenceState,
  (state: StakeholderReferenceState) =>  state.loaded
);

export const getAllStakeholderReference = createSelector(
    getStakeholderReferenceState,
  (state: StakeholderReferenceState) => selectAll(state)
);

export const getStakeholderReferenceEntities = createSelector(
    getStakeholderReferenceState,
  (state: StakeholderReferenceState) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getStakeholderReferenceState,
  (state: StakeholderReferenceState) => state.selectedStakeholderReferenceId
);

export const getSelected = createSelector(
    getStakeholderReferenceEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);



export const getByTypeStakeholderReferenceLoaded = createSelector(
  getStakeholderReferenceState,
(state: StakeholderReferenceState) => state.loaded
);

export const getByTypeStakeholderReferenceError = createSelector(
  getStakeholderReferenceState,
(state: StakeholderReferenceState) =>  state.error
);

export const loadingByTypeStakeholderReference = createSelector(
  getStakeholderReferenceState,
(state: StakeholderReferenceState) =>  state.loaded
);

export const getAllByTypeStakeholderReference = createSelector(
  getStakeholderReferenceState,
(state: StakeholderReferenceState) => selectAll(state)
);

export const getByTypeStakeholderReferenceEntities = createSelector(
  getStakeholderReferenceState,
(state: StakeholderReferenceState) => selectEntities(state)
);



